import router from './router'

export default {
	moduleName: 'contentSearch',
  router
}



// WEBPACK FOOTER //
// ./src/core/modules/contentSearch/index.js